<fullscreen-page class="np-detail-layout">
  <div class="np-detail-left">
    <div class="np-detail-header">
      <div class="np-detail-title-row">
        <dx-button
            class="np-detail-back-btn"
            icon="chevronleft"
            stylingMode="text"
            (onClick)="goBackToPrepareStage()"
        ></dx-button>

        <div class="np-detail-title text-truncate">
          {{ catalogTitle }}
        </div>
      </div>

      <dx-tab-panel
          class="prepare-tabs"
          [dataSource]="tabItems"
          [selectedIndex]="selectedTabIndex"
          [animationEnabled]="true"
          [swipeEnabled]="false"
          [deferRendering]="false"
          (onSelectionChanged)="onTabSelectionChanged($event)"
      >
        <div *dxTemplate="let tab of 'title'">
          <span class="text-truncate">{{ tab.title }}</span>
          <span *ngIf="getTabCount(tab.id) !== null" class="prepare-tab-count">{{ getTabCount(tab.id) }}</span>
        </div>

        <div *dxTemplate="let tab of 'item'"></div>
      </dx-tab-panel>
    </div>

    <div class="np-detail-body">
      <catalog
          class="np-detail-browse d-block h-100"
          [routeBasePath]="'/dataprocess/preparation/catalog'"
          [customerIdOverride]="customerIdFromRoute"
          [catalogIdOverride]="catalogIdFromRoute"
          [additionalFilter]="additionalFilterForBrowseComponent"
          [multiSelect]="isSelectableTab"
          [footerButtons]="footerButtons"
      ></catalog>
    </div>
  </div>

  <div class="np-detail-right-spacer" [class.right-hidden]="!isBrowseTab"></div>

  <help-column
      class="align-self-stretch {{ systemService.showHelp ? '' : 'd-none' }}"
      style="flex: 1 1;"
  ></help-column>
</fullscreen-page>

<np-dialog [popupWidth]="500" [popupHeight]="300"
           [popupTitle]="'Produkte löschen' | translate"
           [(popupVisible)]="deletePopupVisible">
  <div slot="content" class="w-100 h-100">
    <p>
      {{ 'Möchten Sie die ausgewählten Produkte wirklich aus dem Golden-Record-Katalog löschen?' | translate }}
    </p>
    <p>
      {{ 'Anzahl ausgewählter Produkte' | translate }}: <b>{{ selectedProductCount }}</b>
    </p>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'contained', type: 'danger', text: 'Löschen' | translate, onClick: confirmDeleteProducts }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: cancelDeleteProducts }"></np-dialog-button>
  </div>
</np-dialog>

<np-dialog [popupWidth]="500" [popupHeight]="340"
           [popupTitle]="'Produkte auslaufen' | translate"
           [(popupVisible)]="discontinuePopupVisible">
  <div slot="content" class="w-100 h-100">
    <p>
      {{ 'Bitte legen Sie das Auslaufdatum für die ausgewählten Produkte des Golden-Record-Katalogs fest.' | translate }}
    </p>
    <p>
      {{ 'Anzahl ausgewählter Produkte' | translate }}: <b>{{ selectedProductCount }}</b>
    </p>
    <dx-date-box
        [(value)]="discontinueDate"
        type="date"
        displayFormat="dd.MM.yyyy"
        width="100%">
    </dx-date-box>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'contained', type: 'default', text: 'Speichern' | translate, onClick: confirmDiscontinueProducts }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: cancelDiscontinueProducts }"></np-dialog-button>
  </div>
</np-dialog>

<np-dialog [popupWidth]="900" [popupHeight]="700"
           [popupTitle]="'Update zum Golden Record' | translate"
           [(popupVisible)]="updateToCatalogPopupVisible">
  <div slot="content" class="w-100 h-100">
    <userAction-updateToCatalog #updateToCatalogRef
                                *ngIf="updateToCatalogPopupVisible"
                                [presetTargetCatalogIds]="updateToCatalogTargetCatalogIds"
                                [presetUpdateFilter]="updateToCatalogFilter">
    </userAction-updateToCatalog>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'contained', type: 'default', text: 'Update starten' | translate, onClick: startUpdateToCatalog }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: cancelUpdateToCatalog }"></np-dialog-button>
  </div>
</np-dialog>
